import type { FC } from 'react';

import { components } from 'react-select';

export const MenuList: FC<any> = (props) => {
  return (
    <components.MenuList {...props}>
      {props.selectTopContainer && props.selectTopContainer}

      {props.children}
    </components.MenuList>
  );
};
